"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sharedWebSockets = {};
//# sourceMappingURL=globals.js.map